import React from 'react';
import PropTypes from 'prop-types';
import lodashCompact from 'lodash/fp/compact';
import lodashPadStart from 'lodash/padStart';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrInfoTile from 'client/components/SrInfoTile/SrInfoTile';

const SrStripeAccountInfo = ({ stripeAccount }) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });
  if (!stripeAccount) {
    return null;
  }
  const bankInfo = lodashCompact([
    stripeAccount.displayName && {
      label: 'Name on the Account',
      value: stripeAccount.displayName,
    },
    stripeAccount.bankRoutingLast4 && {
      label: 'Routing Number',
      value: lodashPadStart(stripeAccount.bankRoutingLast4, 8, '*'),
    },
    stripeAccount.bankAccountLast4 && {
      label: 'Account Number',
      value: lodashPadStart(stripeAccount.bankAccountLast4, 8, '*'),
    },
    stripeAccount.cardLast4 && {
      label: 'Card',
      value: lodashPadStart(stripeAccount.cardLast4, 8, '*'),
    },
    stripeAccount.cardExpiration && {
      label: 'Expiration',
      value: stripeAccount.cardExpiration,
    },
  ]);
  return (
    bankInfo.map((info, index) => (
      <SrBox
        key={info.label}
        marginBottom='22px'
        marginRight={index !== bankInfo.length - 1 ? !isSmallScreen ? '40px' : null : null}
      >
        <SrInfoTile
          label={info.label}
          value={info.value}
        />
      </SrBox>
    ))
  );
};

SrStripeAccountInfo.propTypes = {
  stripeAccount: PropTypes.object,
};

SrStripeAccountInfo.displayName = 'SrStripeAccountInfo';

export default SrStripeAccountInfo;
